<div class="campaign-container flex-column">
	<div class="flex-row" [ngClass]="isShowAction ? 'campaign-action-border' : ''">
		@if (isShowCuration) {
		<div class="campain-board flex-length max-width-22">
			<div class="flex-row">
				<div class="board-name flex-row">
					<img width="24" height="24" src="./assets/icons/error-outline.svg" alt="Campaign Curation"
						class="campaign-curation-icon" />{{heading}}
				</div>
			</div>
			<div class="campaign-actions flex-row">
				<img width="24" height="24" src="./assets/icons/user_check.svg" alt="Campaign Actions" /> {{subHeading}}
			</div>
		</div>
		}
		@if (isShowAction) {
		<div class="campaign-board-actions flex-length max-width-22">
			<div class="flex-row">
				<div class="board-name flex-row">
					<img width="24" height="24" src="./assets/icons/user_check_color.svg" alt="Campaign Actions"
						class="campaign-action-icon" />{{heading}}
				</div>
			</div>

		</div>
		}
		@if (isScoreBoard === true) {
		@if (campaignType === CAMPAIGN_TYPE.Organization) {
		<div class="score-board flex-length max-width-53">
			@if(isDataCorrections) {
			<div class="score">
				<span class="score-green">{{stats?.cleanRecords || '0'}}</span>
				<label class="label">VALID</label>
			</div>
			<div class="score">
				<span class="score-orange">{{stats?.errorRecords || '0'}}</span>
				<label class="label">ERROR</label>
			</div>
			<div class="score">
				<span class="score-brown">{{stats?.skippedRecordsDuringDataCorrection || '0'}}</span>
				<label class="label">SKIPPED</label>
			</div>
			<div class="score">
				<span class="score-blue">{{stats?.totalRecords || '0'}}</span>
				<label class="label">TOTAL</label>
			</div>
			} @else {
			<div class="score">
				<span class="score-orange">{{needsResolution || '0'}}</span>
				<label class="label">NEEDS RESOLUTION</label>
			</div>
			<div class="score">
				<span class="score-black">{{newSuppliers || '0'}}</span>
				<label class="label">NEW SUPPLIERS</label>
			</div>
			<div class="score">
				<span class="score-green">{{existingSuppliers || '0'}}</span>
				<label class="label">EXISTING SUPPLIERS</label>
			</div>
			<div class="score">
				<span class="score-brown">{{stats?.skippedRecords || '0'}}</span>
				<label class="label">SKIPPED RECORDS</label>
			</div>
			<div class="score">
				<span class="score-blue">{{totalSuppliers || '0'}}</span>
				<label class="label">TOTAL SUPPLIERS</label>
			</div>
			}
		</div>
		} @else {
		<div class="score-board flex-length max-width-53">
			<div class="score">
				<span class="score-blue">{{totalUsers || '0'}}</span>
				<label class="label">TOTAL USERS</label>
			</div>
			<!-- <div class="score">
				<span class="score-black">{{newUsers}}</span>
				<label class="label">NEW USERS</label>
			</div>
			<div class="score">
				<span class="score-green">{{existingUsers}}</span>
				<label class="label">EXISTING USERS</label>
			</div> -->
			<div class="score" tourAnchor="Needs_Resolution">
				<span class="score-orange">{{needsResolution}}</span>
				<label class="label">NEEDS RESOLUTION</label>
			</div>
		</div>
		}
		}
		<div class="action-items flex-length max-width-25">
			<div class="btn-container cursor-pointer">
				<button tourAnchor="Cancel" class="primay-btn no-text-decoration"
					[routerLink]="['/campaign']">CANCEL</button>
			</div>
			@if (isShowCuration) {
			<div class="btn-container" (click)="isValidated && goToActions()">
				<button [ngClass]="isValidated === true ? 'success-btn cursor-pointer' : 'secondary-btn'">NEXT</button>
			</div>
			}
			@if (isShowAction) {
			<div class="btn-container" (click)="isValidated && startToCampaign()">
				<button tourAnchor="start"
					[ngClass]="isValidated === true ? 'success-btn cursor-pointer' : 'secondary-btn'">START</button>
			</div>
			}
		</div>
	</div>
</div>